var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1143_385)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62695 0.00790324H14.7282L16.346 2.97155H19.6794C19.8568 2.97155 20.0016 3.12559 20.0016 3.30308V14.8697C20.0016 15.0472 19.8535 15.2012 19.6794 15.2012H0.322266C0.14974 15.1995 0 15.0505 0 14.8697V3.30308C0 3.12057 0.144857 2.97155 0.322266 2.97155H1.82129V1.90832H3.6735V2.97155H5.68522C6.10352 2.12097 6.52181 1.27206 6.9401 0.421474C7.19401 -0.0959081 7.05404 0.00790324 7.62695 0.00790324ZM17.915 4.43663C18.4456 4.43663 18.8753 4.87867 18.8753 5.42451C18.8753 5.97036 18.4456 6.4124 17.915 6.4124C17.3844 6.4124 16.9548 5.97036 16.9548 5.42451C16.9564 4.87867 17.3861 4.43663 17.915 4.43663ZM10.8464 5.58693C12.4528 5.58693 13.7565 6.92811 13.7565 8.58072C13.7565 10.2333 12.4528 11.5745 10.8464 11.5745C9.23991 11.5745 7.9362 10.2333 7.9362 8.58072C7.9362 6.92811 9.23991 5.58693 10.8464 5.58693ZM10.8464 3.63795C13.501 3.63795 15.6527 5.85148 15.6527 8.58239C15.6527 11.3116 13.501 13.5268 10.8464 13.5268C8.19336 13.5268 6.04004 11.3116 6.04004 8.58239C6.04167 5.85148 8.19336 3.63795 10.8464 3.63795Z",
    fill: "#00BF7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1143_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconGreen);
export default __webpack_public_path__ + "static/media/camera-icon-green.9fb4331bfb5b00c6c9b2fa9e2dd2ef70.svg";
export { ForwardRef as ReactComponent };